export function formatAdminError(err: unknown): string {
  if (err instanceof Error) return err.message;
  if (typeof err === "string") return err;
  if (err && typeof err === "object") {
    const rec = err as Record<string, unknown>;
    const msg =
      (typeof rec.message === "string" && rec.message) ||
      (typeof rec.error === "string" && rec.error) ||
      (typeof rec.details === "string" && rec.details) ||
      (typeof rec.hint === "string" && rec.hint) ||
      "";
    if (msg) return msg;
    try { return JSON.stringify(rec); } catch { return "Unknown admin error"; }
  }
  return "Unknown admin error";
}
